/* The gear menu: a glass panel that drops from the button in the corner. */

.root {
  position: relative;
  flex: none;
}

.menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 250px;
  padding: 6px;
  border-radius: var(--r-md);
  box-shadow: var(--shadow-3);
  opacity: 0;
  /* Visibility, not just opacity: a closed menu must leave the accessibility
     tree and the tab order. Switched at once on the way in, held until the
     fade has finished on the way out. */
  visibility: hidden;
  transform: translateY(-8px) scale(0.97);
  transform-origin: top right;
  transition:
    opacity 0.22s var(--ease),
    transform 0.32s var(--ease),
    visibility 0s linear 0.32s;
  pointer-events: none;
}

.menu.shown {
  opacity: 1;
  visibility: visible;
  transform: none;
  pointer-events: auto;
  transition:
    opacity 0.22s var(--ease),
    transform 0.32s var(--ease),
    visibility 0s;
}

.section {
  padding: 8px 12px 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.item {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) auto 16px;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 40px;
  padding: 0 10px 0 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 560;
  letter-spacing: -0.01em;
  color: var(--ink);
  text-align: left;
  transition:
    background 0.18s,
    transform 0.2s var(--ease);
}

.item:active {
  transform: scale(0.98);
}

@media (hover: hover) {
  .item:hover {
    background: rgba(255, 255, 255, 0.6);
  }
}

.item[aria-checked="true"] {
  color: var(--accent-deep);
}

.icon {
  display: grid;
  place-items: center;
  color: var(--ink-2);
}

.item[aria-checked="true"] .icon {
  color: var(--accent-deep);
}

.icon svg {
  width: 18px;
  height: 18px;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item kbd {
  font-family: var(--font);
  font-size: 11px;
  font-weight: 650;
  min-width: 22px;
  text-align: center;
  padding: 2px 6px;
  border-radius: 6px;
  color: var(--ink-3);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: inset 0 0 0 0.5px rgba(11, 31, 23, 0.12);
}

.check {
  display: grid;
  place-items: center;
  color: var(--accent-deep);
}

.check svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.2;
}

.rule {
  height: 0.5px;
  margin: 6px 10px;
  background: rgba(11, 31, 23, 0.1);
}

/* Fingers do not need the key hints, and the row reads cleaner without them. */
@media (hover: none) {
  .item kbd {
    display: none;
  }
}
